export enum ProjectBillingProvider {
    Invoice = "Invoice",
    Stripe = "Stripe",
    None = "None"
}